let host
  if (window.location.hostname === "localhost" || window.hostname === "127.0.0.1")
    host = "http://localhost:8000"
    //host = "https://bobza.co.za"
  else if(window.location.toString().indexOf("vercel") != -1)
    host = "https://bobza-backend.onrender.com"
  else{
    host = "https://bobza.co.za"
  }

export let server= host;